import { ExclamationCircleOutlined } from '@ant-design/icons';

import { Button, Typography } from 'antd';

const { Text } = Typography;

const CommonModalFooter = ({
  onCancel,
  onSubmit,
  ifSubmitDisabled,
  isCancelDisabled = false,
  warningText,
  loading = false,
  submitButtonLabel,
  dangerSubmitButton = false,
  cancelButtonLabel = 'Cancel'
}) => {
  return (
    <div className="flex jc-space-between ai-center" style={{ gap: 16, flexWrap: 'nowrap' }}>
      <Text style={{ flex: 1, minWidth: 0 }} type="danger">
        {warningText ? <ExclamationCircleOutlined className="mr-8" /> : null}
        {warningText}
      </Text>
      <div className="flex ai-center" style={{ gap: 8, flexShrink: 0 }}>
        <Button disabled={isCancelDisabled} onClick={onCancel}>
          {cancelButtonLabel}
        </Button>
        <Button
          danger={dangerSubmitButton}
          disabled={ifSubmitDisabled}
          loading={loading}
          onClick={onSubmit}
          type="primary">
          {submitButtonLabel || 'Submit'}
        </Button>
      </div>
    </div>
  );
};

export { CommonModalFooter };
